import React from "react";
import { Col, Row } from "react-bootstrap";
import Comment from "./Comment";

const CommentList = props => (
  <Row>
    <Col>
      {(props.comments || []).map(comment => (
        <Comment
          key={comment.id}
          data={comment}
          dpt={0}
          post_id={props.post_id}
        />
      ))}
    </Col>
  </Row>
);

export default CommentList;
